import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Skeleton from '@material-ui/lab/Skeleton';
import clsx from 'clsx';
import { propStr } from '../../../../../../helpers/custom-prop-types';
import SlideSearchPictureIcon from '../../../../../Icon/Svg/SlideSearchPictureIcon';
/**
 * スライド共有、受信共通フッターのスケルトン
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchSlideItemFooterSkeleton = (props) => {
    const { className } = props;
    return (_jsxs("div", Object.assign({ className: clsx('slide_search_item_footer skeleton', className) }, { children: [_jsxs("div", Object.assign({ className: 'footer_slide' }, { children: [_jsx(SlideSearchPictureIcon, { className: 'slide_svg' }), _jsx(Skeleton, { height: 21, variant: 'rect', width: 26 })] })), _jsx("div", Object.assign({ className: 'footer_date' }, { children: _jsx(Skeleton, { height: 21, variant: 'rect', width: 86 }) }))] })));
};
SlideSearchSlideItemFooterSkeleton.propTypes = {
    className: propStr(),
};
SlideSearchSlideItemFooterSkeleton.defaultProps = {
    className: '',
};
export default SlideSearchSlideItemFooterSkeleton;
